import { j as e } from "./jsx-runtime.js";
import { a as I, c as d } from "./Transition.js";
import { d as j } from "./index2.js";
import { Q as C, a as k } from "./index4.js";
import { A as w } from "./index13.js";
import { c as y } from "./index5.js";
import { useMemo as S, Suspense as E } from "react";
import { P as T } from "./index17.js";
import { I as B, C as N, M as P } from "./InputBar.js";
import { d as R } from "./ui-text.js";
import { useChatbotContext as v } from "./useChatbotContext.js";
import { u as D } from "./HotkeyContext.js";
import { ChatMessageFeed as F } from "./ChatMessageFeed.js";
import "react-dom";
import "./has.js";
import "./index14.js";
import "./index15.js";
import "./index10.js";
import "./index6.js";
import "./X.js";
import "./index9.js";
import "./index8.js";
import "./Warning.js";
import "./index7.js";
import "./index3.js";
import "./index11.js";
import "./index12.js";
import "./ChatbotProvider.js";
import "./focus-trap-react.js";
function A(t) {
  const { message: o = "Something went wrong" } = t, { darkMode: a } = j();
  return /* @__PURE__ */ e.jsxs(T, { darkMode: t.darkMode ?? a, variant: "danger", children: [
    o,
    /* @__PURE__ */ e.jsx("br", {}),
    "Reload the page to start a new conversation."
  ] });
}
function he(t) {
  const { darkMode: o } = j(t.darkMode), {
    className: a,
    disclaimer: l,
    disclaimerHeading: x,
    fatalErrorMessage: n,
    initialMessageText: i,
    initialMessageReferences: r,
    initialMessageSuggestedPrompts: m,
    inputBarId: h = "chatbot-input-bar",
    inputBottomText: c,
    windowTitle: s
  } = t, { chatbotName: p, isExperimental: g } = v(), u = S(() => i ? {
    id: crypto.randomUUID(),
    role: "assistant",
    content: i,
    createdAt: (/* @__PURE__ */ new Date()).toLocaleTimeString(),
    suggestedPrompts: m,
    references: r
  } : null, [
    i,
    r,
    m
  ]);
  return /* @__PURE__ */ e.jsx(y, { children: /* @__PURE__ */ e.jsxs(
    w,
    {
      className: I(d`border-radius: 24px;`, a),
      badgeText: g ? "Experimental" : void 0,
      title: s ?? p ?? "",
      darkMode: o,
      children: [
        /* @__PURE__ */ e.jsx(E, { fallback: null, children: /* @__PURE__ */ e.jsx(
          F,
          {
            darkMode: o,
            disclaimer: l,
            disclaimerHeading: x,
            initialMessage: u
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          H,
          {
            id: h,
            fatalErrorMessage: n,
            darkMode: o,
            bottomText: c,
            placeholder: t.inputBarPlaceholder
          }
        )
      ]
    }
  ) });
}
function H({
  darkMode: t,
  fatalErrorMessage: o = R,
  id: a = "chatbot-input-bar",
  bottomText: l,
  placeholder: x = P()
}) {
  var M;
  const { darkMode: n } = j(t), {
    awaitingReply: i,
    conversation: r,
    handleSubmit: m,
    inputBarRef: h,
    inputText: c,
    inputTextError: s,
    maxInputCharacters: p,
    setInputText: g
  } = v(), u = s !== "", b = D();
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: d`
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        margin-top: 1rem;
        padding-left: 32px;
        padding-right: 32px;
        padding-top: 0.5rem;
        padding-bottom: 1rem;
      `,
      children: [
        r.error ? /* @__PURE__ */ e.jsx(A, { darkMode: n, message: r.error }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            B,
            {
              hasError: u,
              shouldRenderGradient: !s,
              darkMode: n,
              ref: h,
              disabled: !!((M = r.error) != null && M.length),
              disableSend: u || i,
              shouldRenderHotkeyIndicator: b.hotkey !== null,
              onMessageSend: (f) => {
                s.length === 0 && !r.error && m(f);
              },
              textareaProps: {
                id: a,
                value: c,
                onChange: (f) => {
                  g(f.target.value);
                },
                placeholder: r.error ? o : x
              }
            }
          ),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: d`
              display: flex;
              justify-content: space-between;
            `,
              children: [
                l ? /* @__PURE__ */ e.jsx(
                  C,
                  {
                    baseFontSize: 13,
                    className: d`
                  text-align: center;
                `,
                    children: l
                  }
                ) : null,
                p ? /* @__PURE__ */ e.jsx(
                  N,
                  {
                    darkMode: n,
                    current: c.length,
                    max: p
                  }
                ) : null
              ]
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(Q, { conversation: r })
      ]
    }
  );
}
function Q({ conversation: t }) {
  return {}.VITE_QA === "true" ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: d`
      display: flex;
      flex-direction: row;
      justify-content: center;
    `,
      children: /* @__PURE__ */ e.jsxs(C, { children: [
        "Conversation ID: ",
        /* @__PURE__ */ e.jsx(k, { children: t.conversationId })
      ] })
    }
  ) : null;
}
export {
  he as ChatWindow
};
